import { render, staticRenderFns } from "./PengajuanEdit.vue?vue&type=template&id=c827297c"
import script from "./PengajuanEdit.vue?vue&type=script&lang=js"
export * from "./PengajuanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports